exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".greenbg[data-v-1a05bd90]{color:#fff;background-color:#2c4340}.title[data-v-1a05bd90]{color:#fff;letter-spacing:.46px;line-height:38px}.words[data-v-1a05bd90]{color:#fff;letter-spacing:0;line-height:30px}.msg[data-v-1a05bd90]{bottom:40px;left:40px}.aboutus-mini[data-v-1a05bd90]{bottom:40px;right:40px;width:400px}.social-mini[data-v-1a05bd90]{top:calc((100vh - 400px)/2 - 100px);right:40px;height:400px}", ""]);

// exports
